<template>
  <div class="mc-request-detail">
    <PageHeader class="mc-request-detail__page-header" :title="title">
      <template #afterTitle>
        <ActionButtons />
      </template>
    </PageHeader>

    <BasicInfoDetail :showResponse="showResponse" />
    <LoadDetail />
  </div>
</template>

<script>
import { computed } from 'vue'

import PageHeader from '@/components/page-header-v2'
import ActionButtons from '../components/ActionButtons'
import BasicInfoDetail from '../components/BasicInfoDetail'
import LoadDetail from '../components/LoadDetail'

import * as Request from '@/services/rest-api/lib/request/request'

export default {
  components: {
    PageHeader,
    ActionButtons,
    BasicInfoDetail,
    LoadDetail,
  },
  provide() {
    return {
      isLoading: computed(() => this.isLoading),
      companyName: computed(() => this.companyName),
      status: computed(() => this.status),
      totalLoadWeight: computed(() => this.totalLoadWeight),
      totalLoadVolume: computed(() => this.totalLoadVolume),
      isBilledCustomerExists: computed(() => this.isBilledCustomerExists),
    }
  },
  data() {
    return {
      isLoading: false,
      showResponse: {},
    }
  },
  computed: {
    title() {
      return this.$t('deliveryRequest.detail.deliveryTitle', { number: this.deliveryNumber })
    },
    deliveryNumber() {
      return this.showResponse?.parent_number || ''
    },
    boxCapacity() {
      return this.showResponse?.parent_box_type.weight_capacity || 0
    },
    totalLoadWeight() {
      return this.showResponse?.parent_load_weight || 0
    },
    totalLoadVolume() {
      return this.showResponse?.parent_load_volume || 0
    },
    companyName() {
      return this.showResponse?.parent_company?.name || ''
    },
    status() {
      return this.showResponse?.status?.name || ''
    },
    isBilledCustomerExists() {
      return this.showResponse?.is_billed_customer_exists || false
    },
  },
  async mounted() {
    this.isLoading = true
    const res = await Request.show(this.$route.params.id)

    if (res.errors) {
      this.$mcToast.error(this.$t('delivery.alert.requestError'))
      return
    }

    this.showResponse = res.data
    this.isLoading = false
  },
}
</script>

<style lang="scss" scoped>
.mc-request-detail {
  &__page-header {
    margin-bottom: 40px !important;
  }
}
</style>
